var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose2 = function SvgClose2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M3.707 2.293 8 6.587l4.293-4.294a1 1 0 0 1 1.414 1.414L9.414 8.001l4.293 4.295a1 1 0 0 1-1.414 1.414L8 9.416 3.707 13.71a1 1 0 0 1-1.414-1.414l4.292-4.295-4.292-4.294a1 1 0 0 1 1.414-1.414z"
  })));
};

export { SvgClose2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZmlsbD0iIzMzMyIgZD0iTTMuNzA3IDIuMjkzIDggNi41ODdsNC4yOTMtNC4yOTRhMSAxIDAgMCAxIDEuNDE0IDEuNDE0TDkuNDE0IDguMDAxbDQuMjkzIDQuMjk1YTEgMSAwIDAgMS0xLjQxNCAxLjQxNEw4IDkuNDE2IDMuNzA3IDEzLjcxYTEgMSAwIDAgMS0xLjQxNC0xLjQxNGw0LjI5Mi00LjI5NS00LjI5Mi00LjI5NGExIDEgMCAwIDEgMS40MTQtMS40MTR6Ii8+PC9zdmc+";